import React from 'react'
import { Table } from 'react-bootstrap'
import ScreenshotPlaceholder from '../../../components/ScreenshotPlaceholder'
import { Tip, Warn, Code, ArticleLink, Ext, TemplateBtn } from '../_helpers'

export const SECTION_ARTICLES = [
  {
    id: 'data-weather',
    category: 'data',
    title: 'Αρχεία καιρού',
    summary: 'Προαιρετικά αρχεία που βελτιώνουν την ακρίβεια των προβλέψεων ηλιακής και αιολικής ενέργειας.',
    body: (
      <>
        <p>
          Τα αρχεία καιρού είναι προαιρετικά, αλλά βελτιώνουν την ακρίβεια των προβλέψεων. Υπάρχουν δύο τύποι.
        </p>
        <h5 className="mt-3">Ηλιακός καιρός</h5>
        <Table bordered size="sm" className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Στήλη</th><th>Απαιτείται;</th><th>Σημασία</th></tr>
          </thead>
          <tbody>
            <tr><td><Code>timestamp</Code></td><td>Απαιτείται</td><td>Η ώρα</td></tr>
            <tr><td><Code>ghi_w_m2</Code></td><td>Απαιτείται</td><td>Ένταση ηλιακής ακτινοβολίας, σε watt ανά τετραγωνικό μέτρο</td></tr>
            <tr><td><Code>temperature_c</Code></td><td>Προαιρετική</td><td>Θερμοκρασία αέρα, °C</td></tr>
            <tr><td><Code>cloud_cover_pct</Code></td><td>Προαιρετική</td><td>Νεφοκάλυψη, 0–100%</td></tr>
            <tr><td><Code>dni_w_m2</Code></td><td>Προαιρετική</td><td>Άμεση ηλιακή ακτινοβολία, W/m²</td></tr>
          </tbody>
        </Table>
        <TemplateBtn type="weather_solar">Πρότυπο ηλιακού καιρού</TemplateBtn>

        <h5 className="mt-4">Αιολικός καιρός</h5>
        <Table bordered size="sm" className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Στήλη</th><th>Απαιτείται;</th><th>Σημασία</th></tr>
          </thead>
          <tbody>
            <tr><td><Code>timestamp</Code></td><td>Απαιτείται</td><td>Η ώρα</td></tr>
            <tr><td><Code>wind_speed_m_s</Code></td><td>Απαιτείται</td><td>Ταχύτητα ανέμου, σε μέτρα ανά δευτερόλεπτο</td></tr>
            <tr><td><Code>wind_direction_deg</Code></td><td>Προαιρετική</td><td>Διεύθυνση ανέμου, 0–360°</td></tr>
            <tr><td><Code>temperature_c</Code></td><td>Προαιρετική</td><td>Θερμοκρασία αέρα, °C</td></tr>
          </tbody>
        </Table>
        <TemplateBtn type="weather_wind">Πρότυπο αιολικού καιρού</TemplateBtn>
        <Tip>Οι προαιρετικές στήλες μπορούν να παραλειφθούν εντελώς — αν όμως συμπεριλάβετε μια στήλη, συμπληρώστε την για κάθε γραμμή.</Tip>

        <h5 className="mt-4">Πού μπορώ να βρω δεδομένα καιρού;</h5>
        <p>
          Σχεδόν ποτέ δεν χρειάζεται να τα καταγράψετε μόνοι σας. Αρκετές δωρεάν υπηρεσίες δημοσιεύουν
          ωριαίο ιστορικό καιρό για οποιαδήποτε τοποθεσία στην Ευρώπη. Ξεκινήστε με τις καθολικές —
          καλύπτουν κάθε χώρα-πιλότο και δεν απαιτούν ειδικό λογαριασμό.
        </p>

        <h6 className="mt-3">Open-Meteo (συνιστάται, πιο εύκολο)</h6>
        <p>
          <Ext href="https://open-meteo.com/en/docs/historical-weather-api">open-meteo.com/en/docs/historical-weather-api</Ext>
          {' '}— δωρεάν, χωρίς λογαριασμό, ωριαίο ιστορικό από το 1940.
        </p>
        <ol>
          <li>Ανοίξτε την παραπάνω σελίδα. Στη φόρμα, εισάγετε το <strong>γεωγραφικό πλάτος και
            μήκος</strong> της κοινότητάς σας (βρείτε τα στο Google Maps — δεξί κλικ στην τοποθεσία → «What's here»).</li>
          <li>Ορίστε <strong>Start date</strong> και <strong>End date</strong> για το έτος που θέλετε.</li>
          <li>Στο <strong>Hourly Variables</strong>, επιλέξτε τα παρακάτω (παραλείψτε τη λίστα ανέμου αν
            χρειάζεστε μόνο ηλιακά, και αντίστροφα):
            <ul>
              <li><Code>shortwave_radiation</Code> — αυτό είναι GHI (σε W/m²).</li>
              <li><Code>direct_radiation</Code> — αυτό είναι DNI (προαιρετικό).</li>
              <li><Code>temperature_2m</Code> — θερμοκρασία αέρα (°C).</li>
              <li><Code>cloud_cover</Code> — νεφοκάλυψη (%).</li>
              <li><Code>wind_speed_10m</Code> — ταχύτητα ανέμου σε ύψος 10 m (m/s).</li>
              <li><Code>wind_direction_10m</Code> — διεύθυνση ανέμου (μοίρες).</li>
            </ul>
          </li>
          <li>Ορίστε τη μορφή σε <strong>CSV</strong> και κάντε κλικ στο <strong>Download</strong>.</li>
          <li>Ανοίξτε το αρχείο. Μετονομάστε τις στήλες που αναμένει η πλατφόρμα:
            {' '}<Code>shortwave_radiation</Code> → <Code>ghi_w_m2</Code>,
            {' '}<Code>direct_radiation</Code> → <Code>dni_w_m2</Code>,
            {' '}<Code>temperature_2m</Code> → <Code>temperature_c</Code>,
            {' '}<Code>cloud_cover</Code> → <Code>cloud_cover_pct</Code>,
            {' '}<Code>wind_speed_10m</Code> → <Code>wind_speed_m_s</Code>,
            {' '}<Code>wind_direction_10m</Code> → <Code>wind_direction_deg</Code>.</li>
          <li>Βεβαιωθείτε ότι η στήλη χρονοσήμανσης ονομάζεται <Code>timestamp</Code>. Αποθηκεύστε ως CSV UTF-8 και
            ανεβάστε το.</li>
        </ol>

        <h6 className="mt-3">PVGIS — Ευρωπαϊκή Επιτροπή JRC (καλύτερο για ηλιακό σχεδιασμό)</h6>
        <p>
          <Ext href="https://re.jrc.ec.europa.eu/pvg_tools/en/">re.jrc.ec.europa.eu/pvg_tools/en/</Ext>
          {' '}— δωρεάν, χωρίς λογαριασμό, καλύπτει όλη την Ευρώπη. Ιδιαίτερα χρήσιμο όταν χρειάζεστε
          ένα «τυπικό έτος» αναφοράς (TMY) αντί για συγκεκριμένο ιστορικό έτος.
        </p>
        <ol>
          <li>Ανοίξτε τον ιστότοπο, επιλέξτε την τοποθεσία σας στον χάρτη.</li>
          <li>Επιλέξτε <strong>«Hourly data»</strong> στις αριστερές καρτέλες.</li>
          <li>Επιλέξτε <strong>Solar radiation components</strong> και <strong>2-m air temperature</strong>,
            επιλέξτε ένα έτος (ή εύρος) και κάντε κλικ στο <strong>Download CSV</strong>.</li>
          <li>Το κατεβασμένο αρχείο έχει μια μικρή κεφαλίδα που μπορεί να χρειαστεί να διαγράψετε,
            ώστε η γραμμή στηλών
            (<Code>time</Code>, <Code>G(i)</Code>, <Code>T2m</Code>, …) να βρίσκεται στη γραμμή 1. Μετονομάστε
            {' '}<Code>G(i)</Code> → <Code>ghi_w_m2</Code> και <Code>T2m</Code> → <Code>temperature_c</Code>.</li>
        </ol>
        <Tip>Οι ώρες του PVGIS είναι συνήθως σε UTC και οι χρονοσημάνσεις μπορεί να μοιάζουν με <Code>20250101:1000</Code>
          — μετατρέψτε τες σε <Code>2025-01-01T10:00:00Z</Code> χρησιμοποιώντας τον τύπο από το
          {' '}<ArticleLink to="data-csv-basics">Δημιουργία αρχείων CSV σωστά</ArticleLink>.</Tip>

        <h6 className="mt-3">Renewables.ninja (ηλιακή / αιολική παραγωγή για συγκεκριμένη τοποθεσία)</h6>
        <p>
          <Ext href="https://www.renewables.ninja">renewables.ninja</Ext> — δωρεάν με γρήγορη
          εγγραφή. Εισάγετε συντεταγμένες, επιλέξτε «MERRA-2» ή «ERA-5», έτος και ανάλυση, και
          κατεβάστε CSV. Η μεταβλητή που αντιστοιχίζεται είναι <Code>irradiance</Code> → <Code>ghi_w_m2</Code> για
          ηλιακά, και <Code>wind_speed</Code> → <Code>wind_speed_m_s</Code> για αιολικά.
        </p>

        <h6 className="mt-3">NASA POWER (παγκόσμια εναλλακτική)</h6>
        <p>
          <Ext href="https://power.larc.nasa.gov/data-access-viewer/">power.larc.nasa.gov/data-access-viewer</Ext>
          {' '}— παγκόσμια ωριαία δεδομένα, δωρεάν. Χρήσιμο όταν άλλες πηγές δεν καλύπτουν την τοποθεσία.
          Ονόματα μεταβλητών: <Code>ALLSKY_SFC_SW_DWN</Code> → <Code>ghi_w_m2</Code>,
          {' '}<Code>T2M</Code> → <Code>temperature_c</Code>,
          {' '}<Code>WS10M</Code> → <Code>wind_speed_m_s</Code>.
        </p>

        <h6 className="mt-3">Εθνικές μετεωρολογικές υπηρεσίες</h6>
        <Table bordered size="sm" responsive className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Χώρα</th><th>Υπηρεσία</th></tr>
          </thead>
          <tbody>
            <tr><td>Ιταλία</td><td>ISPRA / περιφερειακές ARPA (π.χ. ARPA Lombardia, ARPA Veneto) — ωριαία δεδομένα σταθμών ανά περιφέρεια.</td></tr>
            <tr><td>Γαλλία</td><td>Πύλη ανοιχτών δεδομένων Météo-France (<Ext href="https://meteo.data.gouv.fr">meteo.data.gouv.fr</Ext>) — ιστορικές ωριαίες παρατηρήσεις.</td></tr>
            <tr><td>Γερμανία</td><td>DWD Climate Data Center (<Ext href="https://opendata.dwd.de">opendata.dwd.de</Ext>) — δωρεάν, ωριαία δεδομένα σε επίπεδο σταθμού.</td></tr>
            <tr><td>Τσεχία</td><td>CHMI (<Ext href="https://www.chmi.cz">chmi.cz</Ext>) — ιστορικά δεδομένα σταθμών κατόπιν αιτήματος / μέσω πύλης.</td></tr>
            <tr><td>Ελλάδα</td><td>HNMS / NOA-Meteo (<Ext href="https://www.meteo.gr">meteo.gr</Ext>) — περιορισμένα δωρεάν ιστορικά δεδομένα· το Open-Meteo είναι συνήθως πιο εύκολο.</td></tr>
          </tbody>
        </Table>

        <Warn>
          Αντιστοιχίστε το <strong>έτος</strong> και τη <strong>ζώνη ώρας</strong> του αρχείου καιρού
          με τα υπόλοιπα αρχεία σας. Αν τα δεδομένα φορτίου αφορούν το 2024 σε τοπική ώρα, κατεβάστε
          καιρό 2024 σε UTC και μετατρέψτε τον (το Open-Meteo σάς επιτρέπει να επιλέξετε ζώνη ώρας πριν
          από τη λήψη). Αναντίστοιχα έτη ή ζώνες ώρας επιδεινώνουν τις προβλέψεις, αντί να τις βελτιώνουν.
        </Warn>
      </>
    ),
  },

  {
    id: 'data-bill',
    category: 'data',
    title: 'Αρχεία λογαριασμών ενέργειας',
    summary: 'Μηνιαία δεδομένα χρέωσης για ανάλυση κόστους.',
    body: (
      <>
        <p>
          Ένα αρχείο <strong>Λογαριασμού Ενέργειας</strong> καταχωρεί παλιούς λογαριασμούς, μία γραμμή
          ανά περίοδο χρέωσης (συνήθως ένας μήνας). Χρησιμοποιείται για ανάλυση κόστους.
        </p>
        <Table bordered size="sm" className="small">
          <thead style={{ background: 'var(--color-neutral-100)' }}>
            <tr><th>Στήλη</th><th>Απαιτείται;</th><th>Σημασία</th></tr>
          </thead>
          <tbody>
            <tr><td><Code>period_start</Code></td><td>Απαιτείται</td><td>Πρώτη ημέρα του λογαριασμού, π.χ. <Code>2025-01-01</Code></td></tr>
            <tr><td><Code>period_end</Code></td><td>Απαιτείται</td><td>Τελευταία ημέρα του λογαριασμού, π.χ. <Code>2025-01-31</Code></td></tr>
            <tr><td><Code>consumption_kwh</Code></td><td>Απαιτείται</td><td>Συνολική κατανάλωση ηλεκτρικής ενέργειας στην περίοδο, σε kWh</td></tr>
            <tr><td><Code>cost_eur</Code></td><td>Απαιτείται</td><td>Συνολικό ποσό που καταβλήθηκε, σε ευρώ</td></tr>
            <tr><td><Code>peak_demand_kw</Code></td><td>Προαιρετική</td><td>Μέγιστη ζήτηση ισχύος στην περίοδο, σε kW</td></tr>
            <tr><td><Code>rate_eur_per_kwh</Code></td><td>Προαιρετική</td><td>Μέση τιμή ανά kWh</td></tr>
          </tbody>
        </Table>
        <pre style={{ background: 'var(--color-neutral-50)', padding: 12, borderRadius: 6, fontSize: '0.8rem' }}>
{`period_start,period_end,consumption_kwh,cost_eur
2025-01-01,2025-01-31,3850,962.50
2025-02-01,2025-02-28,3520,880.00`}
        </pre>
        <TemplateBtn type="building_energy_bill">Λήψη προτύπου λογαριασμού ενέργειας</TemplateBtn>
        <Warn>Η ημερομηνία έναρξης κάθε περιόδου πρέπει να είναι πριν από την ημερομηνία λήξης, και οι περίοδοι δεν πρέπει να επικαλύπτονται.</Warn>
      </>
    ),
  },
]
